/*
 * Mijntuinklompen.nl, 17 okt 2026 (themaronde 4)
 * Direct toevoegen vanuit productkaarten (42A), "Wat zoek je?" (41A) en "Past erbij" (36A).
 *
 * Opbouw in de HTML (snippet mtk-koop-keuze):
 *   <div data-mtk-koop data-variant-id="(alleen bij één variant)">
 *     <button data-mtk-maat data-variant-id="…" data-maat="39">39</button> …   (of <select data-mtk-koop-select>)
 *     <button data-mtk-koop-knop data-label-kies="Kies je maat" data-label-klaar="In winkelwagen – maat {maat}">…</button>
 *   </div>
 *
 * - Eerst een maat kiezen; zonder maat zegt de knop "Kies je maat" en een klik wijst de maatknoppen aan.
 * - Toevoegen via /cart/add.js met de sections van de winkelwagen-drawer, zodat de drawer
 *   (inclusief de balk naar gratis verzending) en het teller-icoon meteen kloppen.
 * - Eén gedelegeerde listener op document: werkt ook voor kaarten die "Toon meer" later bijlaadt.
 */
(function () {
  if (window.mtkKoop) return;
  window.mtkKoop = true;

  function vul(tpl, maat) {
    return (tpl || '').replace('{maat}', maat || '');
  }

  function zetKnop(box) {
    var knop = box.querySelector('[data-mtk-koop-knop]');
    if (!knop || knop.disabled) return;
    var vid = box.dataset.variantId;
    var tekst;
    if (vid) {
      tekst = vul(knop.dataset.labelKlaar, box.dataset.maat);
    } else {
      tekst = knop.dataset.labelKies;
    }
    var span = knop.querySelector('[data-mtk-koop-tekst]') || knop;
    if (tekst) span.textContent = tekst;
  }

  function kiesMaat(box, chip) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-mtk-maat]'), function (c) {
      var aan = c === chip;
      c.classList.toggle('is-gekozen', aan);
      c.setAttribute('aria-pressed', aan ? 'true' : 'false');
    });
    box.dataset.variantId = chip.dataset.variantId;
    box.dataset.maat = chip.dataset.maat;
    box.classList.remove('is-fout');
    zetKnop(box);
  }

  function wijsMaatAan(box) {
    box.classList.add('is-fout');
    var eerste = box.querySelector('[data-mtk-maat]:not([disabled]), [data-mtk-koop-select]');
    if (eerste) {
      try { eerste.focus({ preventScroll: true }); } catch (e) { eerste.focus(); }
    }
    clearTimeout(box._mtkTimer);
    box._mtkTimer = setTimeout(function () { box.classList.remove('is-fout'); }, 2500);
  }

  function voegToe(box, knop) {
    var vid = Number(box.dataset.variantId);
    if (!vid || knop.getAttribute('aria-busy') === 'true') return;
    knop.setAttribute('aria-busy', 'true');
    knop.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.section; });
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: vid, quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data && (data.description || data.message) || res.status);
          return data;
        });
      })
      .then(function (data) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (data.sections && data.sections['cart-icon-bubble'] && bubble) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data.sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section');
          bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
        }
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data, true);
        } else {
          var items = document.querySelector('cart-items');
          if (items && typeof items.refresh === 'function') {
            if (items.dataset.empty === 'true') window.location.reload();
            else items.refresh();
          }
        }
        knop.classList.add('is-toegevoegd');
        setTimeout(function () { knop.classList.remove('is-toegevoegd'); }, 1600);
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: vid } }));
      })
      .catch(function (err) {
        var melding = box.querySelector('[data-mtk-koop-melding]');
        if (melding) {
          melding.textContent = 'Toevoegen lukte niet. Probeer het opnieuw of open het product.';
          melding.hidden = false;
        }
        console.warn('Toevoegen mislukt', err); // eslint-disable-line no-console
      })
      .finally(function () {
        knop.removeAttribute('aria-busy');
        knop.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;

    var chip = t.closest('[data-mtk-maat]');
    if (chip) {
      var boxC = chip.closest('[data-mtk-koop]');
      if (!boxC || chip.disabled) return;
      evt.preventDefault();
      evt.stopPropagation();
      kiesMaat(boxC, chip);
      return;
    }

    var knop = t.closest('[data-mtk-koop-knop]');
    if (knop) {
      var box = knop.closest('[data-mtk-koop]');
      if (!box) return;
      evt.preventDefault();
      evt.stopPropagation();
      if (knop.disabled) return;
      if (!box.dataset.variantId) {
        wijsMaatAan(box);
        return;
      }
      voegToe(box, knop);
    }
  });

  document.addEventListener('change', function (evt) {
    var sel = evt.target;
    if (!sel || !sel.matches || !sel.matches('[data-mtk-koop-select]')) return;
    var box = sel.closest('[data-mtk-koop]');
    if (!box) return;
    var opt = sel.options[sel.selectedIndex];
    box.dataset.variantId = sel.value || '';
    box.dataset.maat = opt && sel.value ? (opt.dataset.maat || opt.textContent.trim()) : '';
    box.classList.remove('is-fout');
    zetKnop(box);
  });
})();
